import { createContext, useContext, useState, useEffect } from 'react'
import en from './en.json'
import bn from './bn.json'

const translations = { en, bn }
const LanguageContext = createContext()

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try { return localStorage.getItem('pc_lang') || 'en' } catch { return 'en' }
  })

  const switchLang = (l) => {
    setLang(l)
    try { localStorage.setItem('pc_lang', l) } catch {}
  }

  const t = (key, vars = {}) => {
    const keys = key.split('.')
    let val = translations[lang]
    for (const k of keys) val = val?.[k]
    if (!val) {
      // fallback to English if Bengali key missing
      let fallback = translations['en']
      for (const k of keys) fallback = fallback?.[k]
      val = fallback || key
    }
    // Replace {variable} placeholders
    if (typeof val === 'string' && Object.keys(vars).length) {
      Object.entries(vars).forEach(([k, v]) => {
        val = val.replace(new RegExp(`\\{${k}\\}`, 'g'), v)
      })
    }
    return val || key
  }

  useEffect(() => {
    document.documentElement.lang = lang
    document.documentElement.style.fontFamily = lang === 'bn'
      ? "'Hind Siliguri', 'Space Grotesk', system-ui, sans-serif"
      : "'Space Grotesk', system-ui, sans-serif"
  }, [lang])

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useTranslation = () => useContext(LanguageContext)
